import type { PainelPermission } from '@/lib/painel-rbac';

export type CustomPainelRole = {
  id: string;
  name: string;
  description: string;
  permissions: PainelPermission[];
  createdAt: string;
};

const STORAGE_KEY = 'painel_custom_roles';

export function getCustomPainelRoles(): CustomPainelRole[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as CustomPainelRole[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveCustomPainelRoles(roles: CustomPainelRole[]): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(roles));
}

export function createCustomPainelRole(
  input: Pick<CustomPainelRole, 'name' | 'description' | 'permissions'>
): CustomPainelRole {
  return {
    id: `custom-${Date.now()}`,
    name: input.name.trim(),
    description: input.description.trim(),
    permissions: input.permissions,
    createdAt: new Date().toISOString(),
  };
}
